import styles from './ContentCard.module.css';
const IC=['🎬','📺','🎞','📢'];
export default function ContentCard({item,tabIndex,onSelect}) {
  return (<div className={styles.card} onClick={()=>onSelect&&onSelect(item)} style={{cursor:'pointer'}}>
    {item.poster ? <img src={item.poster} alt={item.title} className={styles.img}/>
      : <div className={styles.ph}><span style={{fontSize:36}}>{IC[tabIndex]}</span><span className={styles.pht}>{item.title}</span></div>}
    <div className={styles.body}>
      <div className={styles.title}>{item.title}</div>
      {item.titleEn&&item.titleEn!==item.title&&<div className={styles.en}>{item.titleEn}</div>}
      {item.rating&&<div className={styles.rat}>⭐ {item.rating}{item.votes>0&&<span className={styles.vc}> ({item.votes.toLocaleString()})</span>}</div>}
      {item.genre&&<span className={styles.genre}>{item.genre}</span>}
      {item.stars&&<div className={styles.meta}>👤 {item.stars}</div>}
      {item.channel&&<div className={styles.meta}>📡 {item.channel}</div>}
      {item.description&&<div className={styles.desc}>{item.description.slice(0,100)}{item.description.length>100?"…":""}</div>}
      {item.note&&<div className={styles.note}>💡 {item.note}</div>}
      {item.fromApi&&<div className={styles.tag}>via TMDB</div>}
      {item.fromYoutube&&<div className={styles.tag}>via YouTube</div>}
    </div>
  </div>);
}